// ======================================================================
// Component: ConditionBuilder
// Purpose: Build rule IF conditions dynamically
// ======================================================================

import React from "react";

const OPERATOR_MAP = {
  number: ["=", "!=", ">", "<", ">=", "<="],
  string: ["=", "!=", "CONTAINS"],
  boolean: ["="],
  date: ["=", ">", "<"]
};

export default function ConditionBuilder({
  conditions,
  setConditions,
  eventFields
}) {

  // ------------------------------------------------------------
  // ADD CONDITION
  // ------------------------------------------------------------
  const addCondition = () => {
    setConditions([
      ...conditions,
      { field: "", operator: "=", value: "" }
    ]);
  };

  // ------------------------------------------------------------
  // UPDATE CONDITION
  // ------------------------------------------------------------
  const updateCondition = (index, key, value) => {
    const updated = [...conditions];

    // reset value when field changes
    if (key === "field") {
      updated[index] = {
        field: value,
        operator: "=",
        value: ""
      };
    } else {
      updated[index][key] = value;
    }

    setConditions(updated);
  };

  // ------------------------------------------------------------
  // REMOVE CONDITION
  // ------------------------------------------------------------
  const removeCondition = (index) => {
    setConditions(conditions.filter((_, i) => i !== index));
  };

  return (
    <div>

      <label className="form-label">Conditions (IF)</label>

      {conditions.map((cond, index) => {

        const fieldMeta = eventFields.find(
          f => f.field_key === cond.field
        );

        const operators =
          OPERATOR_MAP[fieldMeta?.data_type] || ["="];

        return (
          <div
            key={index}
            style={{
              display: "flex",
              gap: 8,
              marginBottom: 10,
              alignItems: "center"
            }}
          >

            {/* =====================================================
                FIELD
            ====================================================== */}
            <select
              className="form-select"
              value={cond.field}
              onChange={(e) =>
                updateCondition(index, "field", e.target.value)
              }
            >
              <option value="">Field</option>

              {eventFields.map(f => (
                <option key={f.field_key} value={f.field_key}>
                  {f.field_label}
                </option>
              ))}
            </select>

            {/* =====================================================
                OPERATOR
            ====================================================== */}
            <select
              className="form-select"
              value={cond.operator}
              onChange={(e) =>
                updateCondition(index, "operator", e.target.value)
              }
            >
              {operators.map(op => (
                <option key={op} value={op}>
                  {op}
                </option>
              ))}
            </select>

            {/* =====================================================
                VALUE INPUT (SMART RENDER)
            ====================================================== */}

            {fieldMeta?.lookup_options &&
             fieldMeta.lookup_options.length > 0 ? (

              // -------- DROPDOWN FROM MASTER --------
              <select
                className="form-select"
                value={cond.value}
                onChange={(e) =>
                  updateCondition(index, "value", e.target.value)
                }
              >
                <option value="">Select</option>

                {fieldMeta.lookup_options.map(opt => (
                  <option key={opt.code} value={opt.code}>
                    {opt.name}
                  </option>
                ))}
              </select>

            ) : fieldMeta?.data_type === "boolean" ? (

              // -------- BOOLEAN --------
              <select
                className="form-select"
                value={cond.value}
                onChange={(e) =>
                  updateCondition(index, "value", e.target.value)
                }
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>

            ) : (

              // -------- DEFAULT TEXT INPUT --------
              <input
                className="form-control"
                placeholder="Value"
                value={cond.value}
                onChange={(e) =>
                  updateCondition(index, "value", e.target.value)
                }
              />

            )}

            {/* =====================================================
                REMOVE
            ====================================================== */}
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => removeCondition(index)}
            >
              ✕
            </button>

          </div>
        );
      })}

      {/* =====================================================
          ADD BUTTON
      ====================================================== */}
      <button
        type="button"
        className="btn btn-sm btn-outline-primary"
        onClick={addCondition}
      >
        + Add Condition
      </button>

    </div>
  );
}
